<template>
  <div id="app" class="app">
    <Header/>
    <Sidebar/>
    <router-view/>
    <Footer/>
  </div>
</template>

<script>
import Header from './components/Header.vue';
import Footer from './components/Footer.vue';
import Sidebar from './components/Sidebar.vue';

export default {
  name: 'App',
  components: {
    Header,
    Footer,
    Sidebar,
  },
};
</script>

<style lang="scss">
  // common scss
  @import './assets/scss/bgVideo';
  @import './assets/scss/font';
  @import './assets/scss/common';
</style>
